export const sanitizeBrandDescription = (description: string): string => {
  if (!description) {
    return description;
  }

  return description.replace(/<[^>]*>?/gm, '');
};
